export default class TutorialCategoryBreifSummary
{

    /** @type {number} */
    index;

    /** @type {number} */
    categoryid;

    /** @type {string} */
    category;

    /** @type {string} */
    icon;

    /** @type {boolean} */
    isActive;

    /** @type {TutorialSummary[]} */
    tutorials = [];
}